import { FC, Fragment, useEffect, useState } from 'react';
import { Alert, Card, Col, Form, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from './auth';
import { updatePassword } from 'firebase/auth';
import logo1 from '../assets/images/brand-logos/desktop-dark.png';
import logo2 from '../assets/images/brand-logos/desktop-logo.png';
import apple from '../assets/images/media/apps/apple.png';
import google from '../assets/images/media/apps/google.png';
import SpkButton from '../shared/@spk-reusable-components/reusable-uielements/spk-button';


interface ComponentProps { }

const Forgetpassword: FC<ComponentProps> = () => {

    const [err, setError] = useState("");
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const navigate = useNavigate();


    //Password type visibility function
    const [showPassword1, setShowPassword1] = useState(false);

    const togglePasswordVisibility1 = () => {
        setShowPassword1(!showPassword1);
    };
    const [showPassword2, setShowPassword2] = useState(false);

    const togglePasswordVisibility2 = () => {
        setShowPassword2(!showPassword2);
    };

    const handleResetPassword = async () => {
        try {
            const user = auth.currentUser;
            if (!user) {
                throw new Error("User not authenticated.");
            }

            if (newPassword !== confirmPassword) {
                throw new Error("New password and confirm password do not match.");
            }

            await updatePassword(user, newPassword);
            alert('Password reset successfully.');
            RouteChange();
        } catch (error: unknown) {
            setError(error instanceof Error ? error.message : 'Unable to reset password.');
        }
    };

    const RouteChange = () => {
        let path = `/dashboards/sales/`;
        navigate(path);
    }
    useEffect(() => {
        const body = document.body
        body.classList.add("authentication-background");
        return () => {
            body.classList.remove("authentication-background");
        };
    }, []);

    return (
        <Fragment>
            <div className="container-lg">
                <Row className="justify-content-center align-items-center authentication authentication-basic h-100">
                    <Col xxl={4} xl={5} lg={5} md={6} sm={8} className="col-12">
                        <Card className="custom-card my-4">
                            <Card.Body className="p-5">
                                <div className="mb-3 d-flex justify-content-center">
                                    <Link to={`/dashboards/sales/`}>
                                        <img src={logo2} alt="logo" className="desktop-logo" />
                                        <img src={logo1} alt="logo" className="desktop-dark" />
                                    </Link>
                                </div>
                                <p className="h5 mb-2 text-center">Reset Password</p>
                                <p className="mb-4 text-muted op-7 fw-normal text-center">Choose a new password. No old password is required.</p>
                                {err && <Alert variant='danger'>{err}</Alert>}
                                <Row className="gy-3">
                                    <Col xl={12}>
                                        <Form.Label htmlFor="reset-newpassword" className="text-default">New Password</Form.Label>
                                        <div className="position-relative">
                                            <Form.Control
                                                type={showPassword1 ? 'text' : 'password'}
                                                size='lg'
                                                id="new-password"
                                                placeholder="Enter your new password"
                                                value={newPassword}
                                                onChange={(e) => setNewPassword(e.target.value)}
                                            />
                                            <Link to="#" className="show-password-button text-muted" id="button-addon21" onClick={togglePasswordVisibility1}>{showPassword1 ? <i className="ri-eye-line align-middle"></i> : <i className="ri-eye-off-line align-middle"></i>}</Link>
                                        </div>
                                    </Col>
                                    <Col xl={12} className="mb-2">
                                        <Form.Label htmlFor="reset-confirmpassword" className="text-default">Confirm Password</Form.Label>
                                        <div className="position-relative">
                                            <Form.Control
                                                type={showPassword2 ? 'text' : 'password'}
                                                size='lg'
                                                id="confirm-password"
                                                placeholder="Confirm your new password"
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                            />
                                            <Link to="#" className="show-password-button text-muted" id="button-addon22" onClick={togglePasswordVisibility2}>{showPassword2 ? <i className="ri-eye-line align-middle"></i> : <i className="ri-eye-off-line align-middle"></i>}</Link>
                                        </div>
                                        <div className="mt-3">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" value="" id="defaultCheck1" />
                                                <label className="form-check-label text-muted fw-normal" htmlFor="defaultCheck1">
                                                    Remember password ?
                                                </label>
                                            </div>
                                        </div>
                                    </Col>
                                    <div className="text-center my-3 authentication-barrier">
                                        <span>OR</span>
                                    </div>
                                </Row>
                                <div className="d-grid mb-3">
                                    <SpkButton Buttonvariant='light-ghost' Customclass="btn btn-lg border d-flex align-items-center justify-content-center">
                                        <span className="avatar avatar-xs">
                                            <img src={google} alt="" />
                                        </span>
                                        <span className="lh-1 ms-2 fs-13 text-default">Signin with Google</span>
                                    </SpkButton>
                                </div>
                                <div className="d-grid mb-3">
                                    <SpkButton Buttonvariant='light-ghost' Customclass="btn btn-lg  border d-flex align-items-center justify-content-center">
                                        <span className="avatar avatar-xs invert-1">
                                            <img src={apple} alt="" />
                                        </span>
                                        <span className="lh-1 ms-2 fs-13 text-default">Signin with Apple</span>
                                    </SpkButton>
                                </div>
                                <div className="d-grid mt-4">
                                    <SpkButton Buttonvariant='' Size='lg' onClickfunc={handleResetPassword} Disabled={!newPassword || !confirmPassword}>Reset password</SpkButton>
                                </div>
                                <div className="text-center">
                                    <p className="text-muted mt-3">Already have an account? <Link to={`/common/firebase/signin`} className="text-primary">Sign In</Link></p>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </Fragment>
    );
};

export default Forgetpassword;